import React from 'react';
import { useSelector } from 'react-redux';
// import ActionsPanel from 'src/pages/home/component/actionsPanel';
// import { isMobileView } from 'src/utils/util';
import styled from 'styled-components';
import Datepicker from 'src/common/refactoredComponents/datePicker/DatePicker';
import CalendarIcon from 'src/assets/images/CalendarIcon.svg';
import { MainContainerItems } from 'src/pages/orders/components/orderDetails/backOrderDetails/BackOrderDetails.styled';
import { getPlaceholderDateFormat } from 'src/utils/dateUtils';
import { useTranslation } from 'react-i18next';

// const DateFilterWrapper = styled.div`
//     display: flex;
//     justify-content: center;
//     align-items: center;
// `;

const Title = styled.div`
    color: ${({ color }) => color || '#202124'};
    font-size: ${({ fontSize }) => fontSize || '14px'};
    margin-bottom: ${({ marginBottom }) => marginBottom || '5px'};
    font-family: ${({ fontFamily }) => fontFamily || 'AvenirNextWorld Demi'};
`;

const CommonDateFilter = ({ dateRange, onDateChange, isFim = false, datePickerWidth, marginBottom, defaultDate: defaultDateProp }) => {
    const { t } = useTranslation();
    
    const { defaultDate: fimDefaultDate } = useSelector(
       (state) => state.dashboardFiltersReducer.defaultFilters
    );

    const defaultDate = defaultDateProp || fimDefaultDate;

    // Parse date string as local date to avoid timezone shift
    const toLocalDate = (dateStr) => {
        if (!dateStr) return null;
        if (dateStr instanceof Date) return dateStr;
        const str = String(dateStr);
        // Extract just the date part (YYYY-MM-DD) and build local date
        const [datePart] = str.split('T');
        const [year, month, day] = datePart.split('-').map(Number);
        return new Date(year, month - 1, day);
    };

    // Build ISO string from local date parts to avoid timezone shift
    const toISOFromLocal = (date, type) => {
        if (!date) return '';
        const d = date instanceof Date ? date : new Date(date);
        if (isNaN(d.getTime())) return '';
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        if (type === 'start') return `${year}-${month}-${day}T00:00:00Z`;
        return `${year}-${month}-${day}T23:59:59Z`;
    };

    const handleStartDateChange = (event) => {
        const normalizedStartDate =
            event === null || event === undefined || event === ''
                ? toLocalDate(defaultDate?.surgeryStartDate)
                : event;
        onDateChange?.('surgeryStartDate', toISOFromLocal(normalizedStartDate, 'start'));
    };

    const handleEndDateChange = (event) => {
        const normalizedEndDate =
            event === null || event === undefined || event === ''
                ? toLocalDate(defaultDate?.surgeryEndDate)
                : event;
        onDateChange?.('surgeryEndDate', toISOFromLocal(normalizedEndDate, 'end'));
    };

        return (
        // <DateFilterWrapper>
        //      <ActionsPanel
        //             backgroundColor={'transparent'}
        //             datePickerDivWidth="250px"
        //             datePickerDivHeight="26px"
        //             datePickerDivMbWidth="120px"
        //             datePickerDivMbHeight="28px"
        //             ordersDateIconLeft={'10px'}
        //             startLabelMargin={'0 10px 0px 0'}
        //             endLabelMargin={'10px 10px 5px 0'}
        //             dateMargin={'10px'}
        //             startDate={(!fimStartDate && defaultDate?.surgeryStartDate ? new Date(defaultDate.surgeryStartDate) : '')}
        //             endDate={(!fimEndDate && defaultDate?.surgeryEndDate ? new Date(defaultDate.surgeryEndDate) : '')}
        //             isFim={true}
        //             isOrdersListView={true}
        //             iconHeight={isMobileView() ? '17px' : null}
        //             iconPaddingTop={isMobileView() ? '5%' : null}
        //             iconRight={isMobileView() ? '4%' : null}
        //             isApplyEnabled={() => false}
        //             fromOrderPage={true}
        //             desktopToggleChecked={''}
        //             deniedOverrideToggle={''}
        //             toggleCheckedHandler={''}
        //             deniedOverrideToggleCheck={''}
        //             showToggleButtons={false}
        //             buttonMargin={'2px 0 2px auto'}
        //             filterPanelMargin={'0'}
        //             noPadding={true}
        //             showApplyButton={false}
        //             flexDirection={'column'}
        //             setUserSelectedStartDate={setUserSelectedStartDate}
        //             setUserSelectedEndDate={setUserSelectedEndDate}
        //             userSelectedStartDate={userSelectedStartDate}
        //             userSelectedEndDate={userSelectedEndDate}
        //             dateChangeHandler={() => {}}
        //         />
        // </DateFilterWrapper>
        <MainContainerItems
            width={'100%'}
            marginBottom={marginBottom ? marginBottom : '16px'}
            ipadPadding={'0rem 0.1rem'}
        >
            <div style={{ display: 'flex' }}>
                <div style={{ width: '100%' }}>
                    <Title
                        color={'#202124'}
                        fontSize={'14px'}
                        marginBottom={'5px'}
                        fontFamily={'AvenirNextWorld Regular'}
                    >
                        {t('templates.templatesSearchBox.startDate')}
                    </Title>
                    <Datepicker
                        isFim={isFim}
                        border={'2px solid #ebeded'}
                        iconOpacity={'1'}
                        fontSize={'16px'}
                        placeholder={getPlaceholderDateFormat()}
                        datePickerDivWidth={datePickerWidth || '75%'}
                        datePickerDivMbWidth={'100%'}
                        datePickerDivMbHeight={'5vh'}
                        datePickerDivHeight={'5vh'}
                        maxDate={toLocalDate(dateRange?.surgeryEndDate) || new Date()}
                        minDate={toLocalDate(defaultDate?.surgeryStartDate) || new Date()}
                        defaultClearDate={toLocalDate(defaultDate?.surgeryStartDate)}
                        onChange={handleStartDateChange}
                        datePickerCalendarIcon={CalendarIcon}
                        left={'5px'}
                        selectedDateFromDatePicker={
                            dateRange?.surgeryStartDate
                                ? toLocalDate(dateRange.surgeryStartDate)
                                : defaultDate?.surgeryStartDate
                                    ? toLocalDate(defaultDate.surgeryStartDate)
                                    : null
                        }
                        placeholderColor={'#8f8f8f'}
                        datePickerBgColor={'#FFFFFF'}
                        iconHeight={'30px'}
                        iconPaddingTop={'5%'}
                        iconRight={'5px'}
                        {...(isFim && { panelWidth: '111px', dropdownPanelWidth: '111px' })}
                        //disabled={true}    
                    />
                </div>
                <div style={{ width: '100%', marginLeft: '5px' }}>
                    <Title
                        color={'#202124'}
                        fontSize={'14px'}
                        marginBottom={'5px'}
                        fontFamily={'AvenirNextWorld Regular'}
                    >
                        {t('templates.templatesSearchBox.endDate')}
                    </Title>
                    <Datepicker
                        isFim={isFim}
                        border={'2px solid #ebeded'}
                        placeholderColor={'#8f8f8f'}
                        iconOpacity={'1'}
                        fontSize={'16px'}
                        placeholder={getPlaceholderDateFormat()}
                        datePickerDivWidth={datePickerWidth || '75%'}
                        datePickerDivMbWidth={'100%'}
                        datePickerDivMbHeight={'5vh'}
                        datePickerDivHeight={'5vh'}
                        datePopOverZIndex={999999}
                        maxDate={toLocalDate(defaultDate?.surgeryEndDate) || new Date()}
                        minDate={toLocalDate(dateRange?.surgeryStartDate) || new Date()}
                        defaultClearDate={toLocalDate(defaultDate?.surgeryEndDate)}
                        onChange={handleEndDateChange}
                        datePickerCalendarIcon={CalendarIcon}
                        selectedDateFromDatePicker={
                            dateRange?.surgeryEndDate
                                ? toLocalDate(dateRange.surgeryEndDate)
                                : defaultDate?.surgeryEndDate
                                    ? toLocalDate(defaultDate.surgeryEndDate)
                                    : null
                        }
                        datePickerBgColor={'#FFFFFF'}
                        iconHeight={'30px'}
                        iconPaddingTop={'5%'}
                        iconRight={'5px'}
                        left={'5px'}
                        {...(isFim && { panelWidth: '111px', dropdownPanelWidth: '111px' })}
                    />
                </div>
            </div>
        </MainContainerItems>
    );
};

export default CommonDateFilter;